import { render, staticRenderFns } from "./gps-component-vue.vue?vue&type=template&id=52837b74&scoped=true&shadow"
import script from "./gps-component-vue.vue?vue&type=script&lang=js&shadow"
export * from "./gps-component-vue.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./gps-component-vue.vue?vue&type=style&index=0&id=52837b74&scoped=true&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "52837b74",
  null
  ,true
)

export default component.exports